import React, { useState } from "react";
import { Box, PrimaryButton, SecondaryButton, Text } from "components";
import Drawer from "components/smaltOverwritten/Drawer";
import useWindowDimensions from "hooks/windowDimensions";

const LONG_MESSAGE = (
  <Box
    direction="column"
    gap="m"
    as="section"
    aria-label="Data protection details"
  >
    <Text fontWeight="bold" fontSize="m" mB="xs">
      What we collect:
    </Text>
    <Text fontSize="m" mB="xs">
      Date of birth, gender, nationality
      <br />
      <br />
      Device/browser data, scan timestamps, and scan performance
    </Text>
    <Text fontWeight="bold" fontSize="m" mB="xs">
      Why we collect it:
    </Text>
    <Text fontSize="m" mB="xs">
      To validate your scan
      <br />
      <br />
      To improve service performance and compatibility
    </Text>
    <Text fontWeight="bold" fontSize="m" mB="xs">
      Your data is:
    </Text>
    <Text fontSize="m" mB="xs">
      Processed based on your consent
      <br />
      <br />
      Stored securely and deleted after 7 days
      <br />
      <br />
      May be shared with a trusted validation partner
      <br />
      <br />
      May be transferred outside the EU under Standard Contractual Clauses
      (SCCs)
    </Text>
    <Text fontWeight="bold" fontSize="m" mB="xs">
      Your rights:
    </Text>
    <Text fontSize="m" mB="xs">
      You can withdraw consent at any time
      <br />
      <br />
      You can request to access, correct, restrict, or object to your data
      <br />
      <br />
      Refusing consent will not affect your access to the app, except for scan
      features.
    </Text>
    <Text fontSize="m" mB="xs">
      <b>Controller:</b> AirportLabs 
      <br></br>
      <b>Contact: </b>
      <a href="mailto:support@airportlabs.com">support@airportlabs.com</a>
    </Text>
  </Box>
);

const PreCameraDrawer = ({ isOpen, onContinue, onCancel }) => {
  const { height } = useWindowDimensions();
  const [showDetails, setShowDetails] = useState(false);

  return (
    <Drawer isOpen={isOpen} translationAmount={0} minimumContentHeight={height}>
      <Box
        d="flex"
        direction="column"
        alignItems="center"
        justifyContent="center"
        flex="1"
        gap="l"
        pH="l"
        pV="xl"
        style={{ maxWidth: 480, margin: "0 auto" }}
      >
        <Text fontSize="l" textAlign="center" fontWeight="bold" mB="m">
          We value your privacy.
        </Text>
        <Text fontSize="m" textAlign="left" mB="m">
          To validate scans and improve performance, we process limited
          technical and personal data with your consent. Your data is stored
          securely and automatically deleted after 7 days. Declining will exit
          this feature.
        </Text>
        <Text
          as="button"
          type="button"
          fontSize="m"
          color="primary"
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            padding: 0,
            textDecoration: "underline",
          }}
          aria-expanded={showDetails}
          aria-controls="learn-more-details"
          onClick={() => setShowDetails((v) => !v)}
          mB="m"
        >
          {showDetails ? "Hide details" : "Learn more"}
        </Text>
        {showDetails && (
          <Box id="learn-more-details" w="100%" mB="l">
            {LONG_MESSAGE}
          </Box>
        )}
        <Box
          d="flex"
          gap="base"
          w="100%"
          justifyContent="center"
          style={{ paddingBottom: "230px" }}
        >
          <SecondaryButton onClick={onCancel} style={{ minWidth: 120 }}>
            <Text fontSize="m">Decline</Text>
          </SecondaryButton>
          <PrimaryButton onClick={onContinue} style={{ minWidth: 160 }}>
            <Text fontSize="m">Accept & Continue</Text>
          </PrimaryButton>
        </Box>
      </Box>
    </Drawer>
  );
};

export default PreCameraDrawer;
